import React, { createContext, useEffect, useRef, useState } from 'react';
import api from '../services/api';
import app from '../firebase/config';
import { toast } from 'react-toastify';
export const MarketingContext = createContext({});

function MarketingProvider({ children }) {
    const [link, setLink] = useState()
    const [position, setPosition] = useState()
    const [banners, setBanners] = useState([])
    const [file, setFile] = useState()
    const [imagePreview, setImagePreview] = useState()
    const [modalEdit, setModalEdit] = useState(false)
    const [id,setId] = useState()

    const storage = async () => {

        if (!link) {
            return toast.error("Informe um link", {
                autoClose: 1500
            })
        }


        if (!file) {
            return toast.error("Informe um arquivo", {
                autoClose: 1500
            })
        }

        if (!position) {
            return toast.error("Informe uma posição", {
                autoClose: 1500
            })
        }

        const loadingToastId = toast.loading("Processando imagem...");
        await imageFirebase(position)
        toast.update(loadingToastId, {
            render: "Banner enviado com sucesso!",
            isLoading: false,
            autoClose: 1000
        });
        get()
    }
    const get = async () => {
        const response = await api.get("banner/all/")
        if (response.status == 200) {
            setBanners(response.data)
            return
        }
        setBanners()
    }
    const getById = async (id) => {
        const response = await api.get(`banner/get/by/id/${id}`)
        setModalEdit(true)

        if (response.status == 200) {
            setId(response.data[0].id)
            setLink(response.data[0].url)
            setPosition(response.data[0].mode)
        }
    }
    const update = async () => {

        const loadingToastId = toast.loading("Processando pedido...");

        if (file) {
            await imageFirebaseUpdate()
            get()
            setFile()
            return toast.update(loadingToastId, {
                render: "Banner enviado com sucesso!",
                isLoading: false,
                autoClose: 1000
            });
        }

        const response = await api.put("banner/update", {

            order: "",
            mode: position == "Topo" ? 1 : 2,
            url: link,
            id:id
        })

        if(response.status == 200){
            
            get()
            setFile()

            return toast.update(loadingToastId, {
                render: "Banner alterado com sucesso!",
                isLoading: false,
                autoClose: 1000
            });
        }


    }
    const destroy = async (id) => {
        const response = await api.delete(`banner/delete/${id}`)
        if (response.status == 200) {
            get()
        }
    }
    const handeImage = async (file) => {

        const { type } = file

        const supportedTypes = ["image/png", "image/jpg", "image/jpeg"]
        const verifySupportedType = supportedTypes.includes(type)


        if (!verifySupportedType) {
            return toast.error("Formato de imagem não suportado!")
        }


        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = async () => {
            setImagePreview(reader.result)
            setFile(file)
        }

    }
    const imageFirebase = async (mode) => {

        return app.storage().ref(`/banners/images/${file.name}`).put(file)
            .then(() => {
                return app.storage().ref(`/banners/images/${file.name}`).getDownloadURL();
            })
            .then(image => {
                return api.post("banner/storage", {

                    order: "",
                    mode: position == "Topo" ? 1 : 2,
                    image: image,
                    url: link,
                })

            })
            .catch(error => {
                console.error(`Erro ao carregar a imagem ${file.name}:`, error);
            });


    }
    const imageFirebaseUpdate = async (mode) => {

        return app.storage().ref(`/banners/images/${file.name}`).put(file)
            .then(() => {
                return app.storage().ref(`/banners/images/${file.name}`).getDownloadURL();
            })
            .then(image => {
                return api.put("banner/update", {

                    order: "",
                    mode: position == "Topo" ? 1 : 2,
                    image: image,
                    url: link,
                    id:id
                })

            })
            .catch(error => {
                console.error(`Erro ao carregar a imagem ${file.name}:`, error);
            });


    }
    

    return (
        <MarketingContext.Provider value={{
            storage,
            handeImage,
            get,
            banners,
            setLink,
            link,
            setPosition,
            position,
            destroy,
            getById,
            setModalEdit,
            modalEdit,
            update

        }}>
            {children}
        </MarketingContext.Provider>
    );
}

export default MarketingProvider;
